import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { EVENTS } from '../core/Events'

export default class GTM extends Component {
    constructor(element, options = {}) {
        super(element, options)
    }

    prepare() {
        EventBus.on(EVENTS.MODAL_CLOSE, this.handleModalClose)
        EventBus.on(EVENTS.MODAL_OPEN, this.handleModalOpen)
    }

    destroy() {
        EventBus.off(EVENTS.MODAL_CLOSE, this.handleModalClose)
        EventBus.off(EVENTS.MODAL_OPEN, this.handleModalOpen)
    }

    handleModalClose = data => {
        dataLayer.push(
            {
                'event': 'Modal',
                'eventCategory': data.id,
                'eventAction': 'Zavřít'
            })
    }

    handleModalOpen = data => {
        dataLayer.push(
            {
                'event': 'Modal',
                'eventCategory': data.id,
                'eventAction': 'Otevřít'
            })
    }
}